import { useSelector } from 'react-redux';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import styles from './styles.module.scss';
import MetricChartTooltip from './MetricChartTooltip.jsx';
import { MetricChartDotRadius, MetricChartXAxisHeight, MetricChartYAxisWidth } from './constants/index.jsx';
import { MetricChartHeader } from './index.jsx';
import { BreakpointMobile } from '../../constants/ui';
import { ChartColorsMap } from '../Charts/constants/index.jsx';

const ChartTooltip = ({ active, payload, sensor }) => {
  if (!active || !payload || payload.length < 1) return null;
  const value = payload[0].value;
  const valueCompared =
    payload.length > 1
      ? [
        { name: sensor.name, value: `${value}%`, color: ChartColorsMap.humidity },
        {
          name: sensor.name2,
          value: `${payload[1].value}%`,
          color: ChartColorsMap.humidityCompared,
        },
      ]
      : null;
  return (
    value !== null && <MetricChartTooltip value={`${value}%`} comparedData={valueCompared} />
  );
};

const MetricChartHumidity = ({ title, data, sensor, widthViewport }) => {
  const { selectedSecondarySensor } = useSelector((state) => state.sensors);

  if (!data) {
    return null;
  }

  return (
    <div className={styles.metricChart}>
      {widthViewport > BreakpointMobile &&
        <MetricChartHeader
          title={title}
          sensorName={sensor.name}
          sensorNameCompared={sensor.name2}
          color={ChartColorsMap.humidity}
          colorCompared={ChartColorsMap.humidityCompared}
        />
      }

      <ResponsiveContainer width="100%" height={140} className="chart-report">
        <AreaChart
          width={500}
          height={140}
          data={data.data}
          margin={{
            top: 8,
            right: 8,
            left: 0,
            bottom: 0,
          }}
        >
          <defs>
            <linearGradient id="gradientHumidity" x1="0" y1="0" x2="0" y2="1">
              <stop stopColor={ChartColorsMap.humidity} />
              <stop offset="1" stopColor={ChartColorsMap.humidity} stopOpacity="0" />
            </linearGradient>
            <linearGradient id="gradientHumidity2" x1="0" y1="0" x2="0" y2="1">
              <stop stopColor="#40A9FF" />
              <stop offset="1" stopColor="#40A9FF" stopOpacity="0" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="0 0" stroke={'var(--neutral-8)'} vertical={false} />
          <XAxis dataKey="date" tickLine={false} height={MetricChartXAxisHeight} />
          <YAxis ticks={[0, 50, 100]} tickSize={0} tickMargin={6} width={MetricChartYAxisWidth} domain={[0, 100]} />
          <Tooltip content={<ChartTooltip sensor={sensor} />} />
          <Area
            type="monotone"
            dataKey="value"
            strokeWidth={2}
            stroke={ChartColorsMap.humidity}
            fillOpacity={0.2}
            fill="url(#gradientHumidity)"
            activeDot={{ r: MetricChartDotRadius, fill: '#fff', stroke: ChartColorsMap.humidity }}
          />
          {selectedSecondarySensor && (data.data[0].value2 || data.data[0].value2 === 0) && (
            <Area
              type="monotone"
              dataKey="value2"
              strokeWidth={2}
              stroke={ChartColorsMap.humidityCompared}
              strokeDasharray="2 2"
              fillOpacity={0.2}
              fill="url(#gradientHumidity2)"
              activeDot={{ r: MetricChartDotRadius, fill: '#fff', stroke: ChartColorsMap.humidityCompared }}
            />
          )}
        </AreaChart>
      </ResponsiveContainer>
      <div className={styles.metricChartUnit}>%</div>
    </div>
  );
};

export default MetricChartHumidity;
